module.exports = __webpack_public_path__ + "img/cy.19c11cb.svg";